import React, { ReactElement } from "react"
import { ControlProps } from "./__config/shape"
import SelectField from "../SelectField"
import { CanvasType, KomunikacijaType } from "../../data/_config/shape"
import {
	canvasTypeOptions,
	komunikacijaTypeOptions,
} from "./__config/utilities"

/**
 * Select field for the Canvas Type value
 *
 * @export
 * @param {ControlProps<CanvasType>} {
 * 	onChange,
 * 	value,
 * }
 * @returns {ReactElement}
 */
export default React.memo(function KomunikacijaTypeSelect({
	onChange,
	value,
}: ControlProps<KomunikacijaType>): ReactElement {
	return (
		<SelectField
			name="komunikacijaType"
			value={value}
			label="Komunikacija"
			onChange={onChange}
			options={komunikacijaTypeOptions()}
		/>
	)
})
